import { Navigate, RouteObject } from "react-router-dom";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import { globalOptionsRoute } from "src/routing/domains/libraries/global-options/globalOptionsPaths";

/**
 * `/libraries` index redirect.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → redirect.
 *
 * Intentionally omits a `*` NotFound child so other `/libraries/*` sibling prefixes in
 * `librariesRoutes` can still match. Unknown `/libraries/...` prefixes fall through to `notFoundRoutes`.
 */
export const librariesRootRoute: RouteObject = {
  path: "/libraries",
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [{ Component: ScrollableParentLayout, children: [{ index: true, Component: LibrariesIndexRedirect }] }],
    },
  ],
};

function LibrariesIndexRedirect() {
  return <Navigate to={globalOptionsRoute.url()} replace />;
}
